export default __webpack_public_path__ + "static/media/logo.bbf4e251.webp";